import { ResizeObserverOptions } from '@juggle/resize-observer/lib/ResizeObserverOptions'
import * as React from 'react'
import { ResizeObserver } from '@juggle/resize-observer'
import { useRefDep } from './ref-dep'

const INITIAL_STATE = { width: 0, height: 0 }
const OBSERVER_OPTS: ResizeObserverOptions = { box: 'border-box' }

/**
 * Monitors and returns the element size.
 */
export function useElementSize(ref: React.RefObject<HTMLElement | null>) {
  const [size, setSize] = React.useState(INITIAL_STATE)
  React.useEffect(() => {
    if (!ref.current) {
      setSize(INITIAL_STATE)
      return
    }
    const element = ref.current
    const observer = new ResizeObserver((entries) => {
      entries.forEach((e) => {
        const [{ inlineSize: width, blockSize: height }] = e.borderBoxSize
        setSize({
          width,
          height,
        })
      })
    })
    observer.observe(element, OBSERVER_OPTS)
    return () => {
      observer.unobserve(element)
      observer.disconnect()
    }
  }, [useRefDep(ref)])
  return size
}
